import {Injectable} from '@angular/core';
import {CubejsConfig} from '@cubejs-client/ngx';
import {filter, map, Observable} from 'rxjs';
import {isNotNullOrUndefined} from 'src/app/services/utils/filter-typeguard.util';
import {UserSessionService} from '../../services/session/user-session.service';
import {environment} from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenCubeJsService {

  public config$: Observable<CubejsConfig>;

  constructor(public userSessionService: UserSessionService) {
    this.config$ = this.userSessionService.dataToken$.pipe(
      filter(isNotNullOrUndefined),
      map((authToken) => ({
        token: `${localStorage.getItem(environment.dataTokenTypeNameInSession)} ${authToken}`,
        options: {
          apiUrl: environment.cubeUrlApi,
        },
      }))
    );
  }

}
